module.exports = __webpack_public_path__ + "static/media/jolene-abercromby.ea58f8a9.jpeg";